<template>
  <div class="flex flex-col gap-6">
    <mep-type is="h3" variant="feature-large">The best option is to relocate to a stronger building. Where will you go?</mep-type>
    <div class="flex flex-col gap-2">
      <div class="flex flex-col gap-4">
        <mep-radio-input
          v-for="mepRef33Option in mepRef33Options"
          :key="mepRef33Option"
          v-model="ref33"
          :label="mepRef33OptionLabels[mepRef33Option]"
          :value="mepRef33Option"
        />
      </div>
      <mep-text-input v-if="enableTextInput" v-model="ref33Other" label="Please specify" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { MyEmergencyPlanStageComponent, mepRef33Options, mepRef33OptionLabels, myEmergencyPlanFormSchema } from '@/features';
import { useMyEmergencyPlanStore } from '@/features/my-emergency-plan/presentation/bloc/my-emergency-plan-bloc';
import { storeToRefs } from 'pinia';
import { computed, watch } from 'vue';

const myEmergencyPlanStore = useMyEmergencyPlanStore();
const { nextStageId } = storeToRefs(myEmergencyPlanStore);

const {
  form: { defineField },
} = myEmergencyPlanStore;

const [ref33] = defineField('ref33');
const [ref33Other] = defineField('ref33Other');

const isValid = computed(() => {
  const isRef33Valid = myEmergencyPlanFormSchema.shape.ref33.safeParse(ref33.value).success;
  const isRef33OtherValid = enableTextInput.value ? myEmergencyPlanFormSchema.shape.ref33Other.safeParse(ref33Other.value).success : true;

  return isRef33Valid && isRef33OtherValid;
});

const enableTextInput = computed(() => ref33.value === 'other');

watch(
  isValid,
  (newVal) => {
    myEmergencyPlanStore.isStageValid = newVal;
  },
  { immediate: true }
);

nextStageId.value = 'REF34';
const onPrimaryButtonClicked = () => {
  myEmergencyPlanStore.nextStage();
};

defineExpose<MyEmergencyPlanStageComponent>({
  onPrimaryButtonClicked,
});
</script>
